import { render, staticRenderFns } from "./FolderSkeleton.vue?vue&type=template&id=1723b81a&scoped=true"
var script = {}
import style0 from "./FolderSkeleton.vue?vue&type=style&index=0&id=1723b81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723b81a",
  null
  
)

export default component.exports